import Head from "next/head";
import MainLayout from "@/Component/MainLayout";

export default function LoginPage() {
  return (
    <>
      {/* <Head>
        <title>Login | Next Holidays</title>
      </Head> */}
      {/* <MainLayout hideHeader> */}
        <div style={{ minHeight: "40vh" }} aria-hidden="true" />
      {/* </MainLayout> */}
    </>
  );
}
